import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Login.module.css';
import { loginUser } from '../Api/loginApi.js';

const Login = ({ setUserData }) => {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const loadBootstrap = () => {
      if (document.getElementById('bootstrap-css')) return;
      const link = document.createElement('link');
      link.id = 'bootstrap-css';
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css';
      document.head.appendChild(link);
    };

    const loadBootstrapIcons = () => {
      if (document.getElementById('bootstrap-icons')) return;
      const link = document.createElement('link');
      link.id = 'bootstrap-icons';
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css';
      document.head.appendChild(link);
    };

    loadBootstrap();
    loadBootstrapIcons();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await loginUser(userId, password);

    setLoading(false);

    if (!result.success) {
      setError(result.message);
      return;
    }

    // session is already persisted by loginApi — just update app state
    setUserData(result.user, result.token, result.storeConfig);

  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.contentWrapper}>
        <div className="row w-100 g-0" style={{ minHeight: '100%' }}>

          {/* Right Section - Login Form */}
          <div className={`col-12 col-lg-7 d-flex align-items-center justify-content-center ${styles.formSection}`}>
            <div className={styles.loginCardWrapper}>

              {/* Mobile Brand - Shows only on mobile/tablet */}
              <div className={`d-lg-none text-center ${styles.mobileBrand}`}>
                <div className={styles.logoWrapper}>
                  <h1 className={styles.brandLogo} style={{
                    fontSize: '2.5rem',
                    fontWeight: '800',
                    color: '#c41e3a',
                    letterSpacing: '0.4rem',
                    marginBottom: '0.5rem'
                  }}>
                    SOGANI
                  </h1>
                  <p className={styles.brandName} style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#2c3e50',
                    letterSpacing: '0.2rem',
                    marginBottom: '0'
                  }}>
                    UNIFORMS
                  </p>
                </div>
              </div>

              {/* Login Card */}
              <div className={`card ${styles.loginCard}`}>
                <div className={`card-body p-5 ${styles.cardBody}`}>

                  <form onSubmit={handleLogin}>
                    {/* User ID Field */}
                    <div className="mb-4">
                      <label htmlFor="userId" className={`form-label ${styles.formLabel}`}>
                        User ID
                      </label>
                      <div className="input-group">
                        <span className={`input-group-text ${styles.inputIcon}`}>
                          <i className="bi bi-person-fill"></i>
                        </span>
                        <input
                          type="text"
                          className={`form-control ${styles.formInput}`}
                          id="userId"
                          value={userId}
                          onChange={(e) => setUserId(e.target.value)}
                          placeholder="Enter your user ID"
                          required
                          disabled={loading}
                        />
                      </div>
                    </div>

                    {/* Password Field */}
                    <div className="mb-4">
                      <label htmlFor="password" className={`form-label ${styles.formLabel}`}>
                        Password
                      </label>
                      <div className="input-group">
                        <span className={`input-group-text ${styles.inputIcon}`}>
                          <i className="bi bi-lock-fill"></i>
                        </span>
                        <input
                          type={showPassword ? "text" : "password"}
                          className={`form-control ${styles.formInput}`}
                          id="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Enter your password"
                          required
                          disabled={loading}
                        />
                        <button
                          className={`btn ${styles.passwordToggle}`}
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          disabled={loading}
                        >
                          <i className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`}></i>
                        </button>
                      </div>
                    </div>

                    {/* Error Message */}
                    {error && (
                      <div className={`alert alert-danger ${styles.errorAlert}`} role="alert">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        {error}
                      </div>
                    )}

                    {/* Login Button */}
                    <button
                      type="submit"
                      className={`btn w-100 ${styles.loginButton}`}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Logging in...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-box-arrow-in-right me-2"></i>
                          LOGIN
                        </>
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className={styles.siteFooter}>
        <div className="container-fluid">
          <div className="row g-2">
            <div className="col-12">
              <div className={styles.footerContent}>
                <span className={styles.footerItem}>
                  <i className="bi bi-telephone-fill"></i>
                  <strong>Contact:</strong> 0731 495 7094
                </span>
                <span className={`${styles.footerSeparator} d-none d-md-inline`}>|</span>
                <span className={styles.footerItem}>
                  <i className="bi bi-envelope-fill"></i>
                  <strong>Email:</strong> info@company.com
                </span>
                <span className={`${styles.footerSeparator} d-none d-lg-inline`}>|</span>
                <span className={`${styles.footerItem} d-none d-lg-inline`}>
                  <i className="bi bi-geo-alt-fill"></i>
                  <strong>Address:</strong> UG 17, Hotel Crown Place, Opposite Jain Samvsharan Mandir, 18 Road, Trade Centre, South Tukoganj, Indore, Madhya Pradesh 452001
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Login;